import { render, staticRenderFns } from "./ListBatchs.vue?vue&type=template&id=f75cae48"
import script from "./ListBatchs.vue?vue&type=script&lang=js"
export * from "./ListBatchs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports